import React, { ReactElement } from "react";
import {
  OverigeFinancieelPost,
  VoorstelOverigeFinancielePostenHoofdstuk,
} from "../../../../../.generated/rapportage/rapportagetypes";
import Table from "../../../components/Table";
import { Paragraph } from "../../../components/Paragraph";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { getOverigeFinancielePostenColumns } from "../../Producten/overige-financiele-posten-kolommen";

export const OverigeFinancielePostenData = ({
  overigeFinancielePost,
}: {
  overigeFinancielePost: OverigeFinancieelPost;
}): ReactElement => {
  const data = new Array(overigeFinancielePost);
  return (
    <>
      {data.length > 0 && (
        <Table
          data={data}
          columns={getOverigeFinancielePostenColumns()}
          rotate={true}
          filterNullAnd0Columns={true}
        />
      )}
    </>
  );
};

type OverigeFinancielePostenProps = {
  hoofdstuk: VoorstelOverigeFinancielePostenHoofdstuk;
};

export const OverigeFinancielePostenChapter = ({
  hoofdstuk,
}: OverigeFinancielePostenProps): ReactElement => {
  return (
    <Chapter>
      {hoofdstuk.titel && <Heading text={`${hoofdstuk.titel}`} level={3} />}

      <Paragraph paragraaf={hoofdstuk?.paragrafen?.["p305060901"]} />

      {hoofdstuk.overigeFinancielePosten?.map(
        (overigeFinancielePost, index) => {
          return (
            <OverigeFinancielePostenData
              key={`OverigeFinancielePosten-${index}`}
              overigeFinancielePost={overigeFinancielePost}
            />
          );
        }
      )}
    </Chapter>
  );
};
